import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { useApplicationContext } from '../ApplicationContext';

export const SearchBlockContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest | null>('searchStringMicrofrontendManifest');
  const isSearchEnabled = config.get<boolean>('mobile-mainpage-frontend.textSearch.Enabled');

  if (!isSearchEnabled) {
    return null;
  }

  return (
    <>
      {manifest && (
        <Microfrontend
          name={manifest.microfrontendName}
          image={manifest.imageVersion}
          runtime={manifest.runtimeName}
          instance={manifest.instanceId}
        />
      )}
    </>
  );
};

SearchBlockContainer.displayName = 'SearchBlockContainer';
